/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscrepanciesRequest } from '../../models/discrepancies-request';
import { DiscrepanciesResponse } from '../../models/discrepancies-response';
import { KeyType } from '../../models/key-type';

export interface PutConsigneeDiscrepancies$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
      body: DiscrepanciesRequest
}

export function putConsigneeDiscrepancies(http: HttpClient, rootUrl: string, params: PutConsigneeDiscrepancies$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscrepanciesResponse>> {
  const rb = new RequestBuilder(rootUrl, putConsigneeDiscrepancies.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscrepanciesResponse>;
    })
  );
}

putConsigneeDiscrepancies.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/discrepancies';
